// Agent catalogue — original starter operators with balance passives.
// Adding a new agent: extend AGENTS and (optionally) provide a glTF model URL.
export const AGENTS = {
    recruit: {
        id: "recruit",
        name: "RECRUIT",
        tag: "Balanced",
        description: "Standard tactical operator. All-rounder loadout, neutral posture.",
        modelUrl: null,
        passive: {
            // Balanced — small boost across the board
            maxHp: 100,
            moveSpeedMult: 1.0,
            footstepVolumeMult: 1.0,
            damageMult: 1.0,
            reloadSpeedMult: 1.05,
            perkTitle: "All-Rounder",
            perkDesc: "5% faster reloads across every weapon.",
        },
        palette: {
            skin: "#c7a483", hair: "#241a12", shirt: "#2f3541", shirtDark: "#1e232c",
            trousers: "#1a1a1e", boots: "#0e0e10", gloves: "#111318", vest: "#2a2823",
            beltAccent: "#a8621a", metal: "#3a3a40",
        },
    },
    vanguard: {
        id: "vanguard",
        name: "VANGUARD",
        tag: "Heavy",
        description: "Front-line pusher. Reinforced vest, darker fatigues, olive accents.",
        modelUrl: null,
        passive: {
            maxHp: 125,             // tankier
            moveSpeedMult: 0.9,     // slower
            footstepVolumeMult: 1.2,
            damageMult: 1.0,
            reloadSpeedMult: 0.95,  // slightly slower reload
            perkTitle: "Reinforced",
            perkDesc: "+25 max HP. Moves 10% slower.",
        },
        palette: {
            skin: "#b3865e", hair: "#0f0a06", shirt: "#2b3021", shirtDark: "#1a1e14",
            trousers: "#141613", boots: "#0a0a0a", gloves: "#0d1010", vest: "#3b402a",
            beltAccent: "#7ea850", metal: "#404038",
        },
    },
    ghost: {
        id: "ghost",
        name: "GHOST",
        tag: "Recon",
        description: "Silent flanker. Low-vis grey kit, urban tones, gloves and hood.",
        modelUrl: null,
        passive: {
            maxHp: 90,
            moveSpeedMult: 1.08,        // faster
            footstepVolumeMult: 0.35,   // very quiet
            damageMult: 1.0,
            reloadSpeedMult: 1.0,
            perkTitle: "Silent Steps",
            perkDesc: "Nearly silent footsteps. 8% faster movement.",
        },
        palette: {
            skin: "#a89076", hair: "#1a1a1a", shirt: "#1b1e22", shirtDark: "#0f1114",
            trousers: "#0f1114", boots: "#050505", gloves: "#0a0c10", vest: "#232628",
            beltAccent: "#7a8b95", metal: "#4a4d52",
        },
    },
};

export const AGENT_ORDER = ["recruit", "vanguard", "ghost", "marksman"];
export const DEFAULT_AGENT = "recruit";

export const AGENTS_EXTRA_MARKSMAN = true; // keep bundlers happy re: side-effect free

// Marksman is registered by extending AGENTS after declaration below
AGENTS.marksman = {
    id: "marksman",
    name: "MARKSMAN",
    tag: "Sharpshooter",
    description: "Long-range specialist. Steady posture, muted forest palette.",
    modelUrl: null,
    passive: {
        maxHp: 95,
        moveSpeedMult: 0.95,
        footstepVolumeMult: 1.0,
        damageMult: 1.0,
        headshotBonus: 1.3,
        adsSpeedMult: 0.75,
        reloadSpeedMult: 0.9,
        perkTitle: "Steady Shot",
        perkDesc: "+30% headshot damage. Aim-down-sight 25% slower.",
    },
    palette: {
        skin: "#b89275", hair: "#2a1f14", shirt: "#3a3325", shirtDark: "#20180f",
        trousers: "#191512", boots: "#0f0b08", gloves: "#251f16", vest: "#42371f",
        beltAccent: "#c48c2c", metal: "#382e1f",
    },
};

export function getAgent(id) {
    return AGENTS[id] || AGENTS[DEFAULT_AGENT];
}

// Deterministic agent picker for a friend code (used to preview a teammate's
// operator before real multiplayer). Same code → same agent.
export function agentForCode(code) {
    if (!code) return AGENTS[DEFAULT_AGENT];
    let hash = 0;
    for (let i = 0; i < code.length; i++) hash = (hash * 31 + code.charCodeAt(i)) | 0;
    const idx = Math.abs(hash) % AGENT_ORDER.length;
    return AGENTS[AGENT_ORDER[idx]];
}
